import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const countriesAdapter = getAdapter({ idFieldName: 'value' });

const countriesSlice = createSlice({
  name: 'countries',
  initialState: countriesAdapter.getInitialState({
    source: null
  }),
  reducers: {
    setCountries: (state, { payload: { countries, source } }) => {
      countriesAdapter.setAll(state, countries);
      state.source = source;
    }
  }
});

const selectors = countriesAdapter.getSelectors(({ countries }) => countries);

export const getCountries = state => selectors.selectAll(state);

export const { setCountries } = countriesSlice.actions;

export default countriesSlice.reducer;
